import React from 'react';
import BundlePriceCardComponent from './bundlePriceCardComponent';

function RatesCard({
    backgroundColor,
    logo,
    topText,
    title = "1 Day Data Bundle",
    linkedProducts = [],
    bottomImage,
    bottomText,
    button,
    callToAction,
    ctaColor
}) {
    return (
        <div style={{ position: "relative", flex: 1 }}>
            {callToAction && (
                <div className="bestRates" style={{ 
                    backgroundColor: ctaColor || "" 
                }}>
                    {callToAction}
                </div>
            )}
            <div className='ratesCard' style={{ backgroundColor: backgroundColor || '' }}>
                {logo && logo !== '' ? (
                    <div className="ratesHeader">
                        <div styleClass='topLogo'>
                            <img src={logo} alt="Logo"></img>
                        </div>
                    </div>
                ) : (
                    <div className="ratesHeader">
                        <div className='ratesTopText'>{topText}</div>
                    </div>
                )}
                
                <div className="bundlePriceCardTitle">{title}</div>

                {linkedProducts && linkedProducts.slice(0, 100).map((productItem, productIndex) => (
                    <BundlePriceCardComponent 
                        key={productIndex}
                        productItemText={productItem.displayText} 
                        productItemPrice={productItem.normalPrice} 
                    />
                ))}
                
                <div className='ratesFooter'>
                    {bottomImage && bottomImage !== '' && (
                        <div style={{ textAlign: 'center' }}>
                            <img className='bottomImage' src={bottomImage} alt="Bottom"></img>
                        </div>
                    )}

                    {bottomText && (
                        <div>{bottomText}</div>
                    )}

                    {button && (
                        <div className='buttonContainer ratesFooter' style={{ textAlign: button.position }}>
                            <div style={{ 
                                display: 'inline-block', 
                                padding: '5px 15px 5px 15px', 
                                background: button.backgroundColor || '', 
                                borderRadius: '50px' 
                            }}>
                                <div>{button.buttonText}</div>
                                <div>{button.secondaryText}</div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default RatesCard;